<template>
<!-- 临床研究搜索列表 -->
  <div class="clinicalTrials" v-loading.fullscreen="loading" element-loading-text="拼命加载中">
    <viewHeader :keywords="keyword"></viewHeader>
    <div class="content">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix header-box">
          <img src="../assets/img/icon0.png" alt="" class="L" />
          <span class="L">{{ keyword }}</span>
          <el-button v-if="hasData" class="R" style="padding: 3px 0" type="text" @click="handleAnalysis">研究总结</el-button>
        </div>
        <div class="resultTtle">
          <p class="pointData el-icon-warning-outline" v-if="preNumFound === 0 && totalNum !== 0">
            未找到匹配的研究，推荐您阅读以下相关研究
          </p>
          <div class="totalnum-box">
            <p class="totalnum-case">共为您找到 <span>{{ totalNum || 0 }}</span> 项研究</p>
            <div class="filter-box">
              <div class="filter-list">
                <el-dropdown trigger="click" placement="bottom" style="cursor: pointer" @command="handleCommand($event, false)">
                  <span class="el-dropdown-link">
                    注册时间<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in regdateOptions" :key="index"
                      :command="{ value: item, name: 'regdate' }">
                      <span v-if="item === '全部'">{{ item }}</span>
                      <span v-else-if="item !== '全部'">近{{ item }}年</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="filter-list">
                <el-dropdown trigger="click" placement="bottom" style="cursor: pointer" @command="handleCommand($event, true)">
                  <span class="el-dropdown-link">
                    研究状态<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in statusOptions" :key="index"
                      :command="{ value: item, name: 'status' }">{{ item | filtersNameMap }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="filter-list">
                <el-dropdown trigger="click" placement="bottom" style="cursor: pointer" @command="handleCommand($event, true)">
                  <span class="el-dropdown-link">
                    研究类型<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in typeOptions" :key="index"
                      :command="{ value: item, name: 'study_type' }">{{ item | filtersNameMap }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="filter-list">
                <el-dropdown trigger="click" placement="bottom" style="cursor: pointer" @command="handleCommand($event, true)">
                  <span class="el-dropdown-link">
                    临床试验阶段<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in rctPhaseOptions" :key="index"
                      :command="{ value: item, name: 'rct_phase' }">{{ item | filtersNameMap }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="sort-box">
              <span class="L sort_sp">排序：</span>
              <el-select
                v-model="sortText"
                @change="handleCommandSort"
                placeholder="请选择"
                size="small"
                class="L"
            >
                <el-option
                v-for="(item, index) in sort"
                :key="index"
                :label="item"
                :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="tags" v-if="tags.length !== 0">
          <el-row>
            <el-col :span="20">
              <el-tag
                closable
                v-for="(tag, tagIndex) in tags"
                :key="tagIndex"
                @close="closeTags(tag, tagIndex)"
              >
                {{ tag | filtersNameMap }}
              </el-tag>
            </el-col>
            <el-col :span="4" class="clearBtn" v-if="tags.length !== 0">
              <img src="../assets/img/clear.png" alt="" />
              <el-link type="primary" @click="clearFilter">清空筛选条件</el-link>
            </el-col>
          </el-row>
        </div>
        <div class="resultList" v-show="hasData">
          <ul>
            <li class="item" v-for="(item, index) in searchData" :key="item.registration">
              <TrialItem :trialItemData="item"></TrialItem>
            </li>
          </ul>
        </div>
        <div class="page">
          <el-pagination background :hide-on-single-page="true" :current-page="pageNum"
            :page-size="pageSize" @current-change="handleCurrentChange" layout="prev, pager, next" :total="totalNum">
          </el-pagination>
        </div>
      </el-card>
      <div class="noData" v-show="!hasData">
        <img src="../assets/img/empty.png" alt="" />
        <span>空空如也，重新搜搜看看吧~</span>
      </div>
    </div>
  </div>
</template>
<script>
import viewHeader from "./viewHeader";
import { webTrackerEvent } from "../utils/tracker";
import { trialSearch } from '../service/getData'
import { clinicalTrialsFilters } from '../utils/articleTags'
import TrialItem from '../components/TriaItem.vue'
export default {
  name: "clinicalTrials",
  components: {
    viewHeader,
    TrialItem
  },
  data() {
    return {
      keyword: "", // 搜索的关键字
      hasData: false, // 是否有数据
      loading: false, // 页面加载动画
      searchData: [], // 搜索出的文献数据
      pageNum: 1, // 当前页
      pageSize: 10, // 每页数量
      totalNum: 0, // 搜索出的总数
      sort: [
        "相关性从高到低",
        "注册时间从近到远",
        "注册时间从远到近"
      ],
      regdateOptions: ["1", "2", "5", "10"],// 注册时间可选项
      statusOptions: ["Completed","Recruiting","Enrolling by invitation",'Not yet recruiting',"Active not recruiting","Suspended","Withheld","Withdrawn","Terminated","Approved for marketing","Available","Temporarily not available","No longer available","Unknown"],// 研究状态可选项
      rctPhaseOptions: ["Early Phase1","Phase1","Phase2","Phase3","Phase4"],// 临床试验阶段可选项
      typeOptions: ["Interventional","Observational","Expanded access"],// 研究类型可选项
      filter: {
        regdate: [],
        rct_phase: [],
        status: [],
        study_type: []
      },
      sortText: "相关性从高到低",
      tags: [], // 过滤条件
      tagsJson: {},
      preNumFound: 1, //如果为0，提示用户没找到相关文献，并推荐其他文献
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
    }
  },
  filters: {
    filtersNameMap(enName) {
      const phaseNameReg = /(Phase)(\d)$/;

      if(enName == '全部') return enName;
      if(phaseNameReg.test(enName)) {
        const cnName = clinicalTrialsFilters[enName];
        return `${String(enName).replace(/(\d+)/g, ' $1')}（${cnName}）`
      } else if(clinicalTrialsFilters[enName]) {
        return `${enName}（${clinicalTrialsFilters[enName]}）`;
      } else {
        return enName;
      }
    }
  },
  methods: {
    /**
     * 进行研究搜索
     */
    async handleSearch(keyword = '') {
      this.loading = true;
      this.keyword = keyword || this.keyword;
      const params = {
        keyword: this.keyword,
        filters: {
          regdate: this.filter.regdate[0] || '',
          rct_phase: this.filter.rct_phase.join('|'),
          status: this.filter.status.join('|'),
          study_type: this.filter.study_type.join('|')
        },
        pages: {
          limit: this.pageSize,
          page: this.pageNum
        },
        sort: this.sortText
      }
      const res = await trialSearch(params);
      this.loading = false;
      if (res && res.data.status === 0) {
        this.isShow = true;
        this.totalNum = res.data.numFound;
        this.preNumFound = res.data.pre_numFound;
        if (res.data.data.length === 0) {
          this.hasData = false;
          return;
        }
        this.hasData = true;
        this.searchData = res.data.data;

        // log
        let Logger = webTrackerEvent();
        Logger.push("eventType", "search");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("searchType", 'clinicalTrial');
        Logger.push("searchText", keyword || this.keyword);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.push("pageUrl", window.location.href);
        Logger.logger();
      } else {
        this.isShow = true;
        this.loading = false;
        this.hasData = false;
      }
    },
    /**
     * 处理过滤条件
     */
    handleCommand(command, multiple) {
      const {value,name} = command;
      const selectedList = this.tagsJson[name];
      if(selectedList) {
        const isExist = selectedList.find(item => item == value);
        if(isExist) {
          return;
        }
      } else if(value == '全部') {
        return;
      }

      // 修改过滤条件
      if (command.value === "全部") {
        this.filter[command.name] = [];
      } else {
        if(multiple) {
          this.filter[command.name].push(command.value);
        } else {
          this.filter[command.name] = [command.value];
        }
      }
      // 获取过滤条件 标签显示
      if (command.name === "regdate") {
        if (command.value !== "全部") {
          if(multiple) {
            this.tagsJson[command.name] ? this.tagsJson[command.name].push("近" + command.value + "年") : this.tagsJson[command.name] = ["近" + command.value + "年"];
          } else {
            this.tagsJson[command.name] = ["近" + command.value + "年"];
          }
        } else {
          delete this.tagsJson["regdate"];
        }
      } else {
        if (command.value !== "全部") {
          if(multiple) {
            this.tagsJson[command.name] ? this.tagsJson[command.name].push(command.value) : this.tagsJson[command.name] = [command.value];
          } else {
            this.tagsJson[command.name] = [command.value];
          }
        } else {
          delete this.tagsJson[command.name];
        }
      }
      this.tags = [];
      for (const name in this.tagsJson) {
        this.tags.push(...this.tagsJson[name]);
      }
      this.showTags = true;
      this.pageNum = 1;
      this.handleSearch();
    },
    /**
     * 删除单个过滤标签
     */
    closeTags(tag, tagIndex) {
      for (const name in this.tagsJson) {
        const selectedList = this.tagsJson[name];
        const index = selectedList.findIndex(item => item == tag);
        if(index > -1) {
          selectedList.splice(index,1);

          const filterIndex = this.filter[name].findIndex(item => {
            if(name == 'regdate') {
              return `近${item}年` == tag;
            } else {
              return item == tag;
            }
          });
          if(filterIndex > -1) {
            this.filter[name].splice(filterIndex,1);
          }
          break;
        }
      }
      this.tags.splice(tagIndex, 1);
      if (this.tags.length === 0) {
        this.tagsJson = {};
      }
      this.loading = true;
      this.pageNum = 1;
      this.handleSearch();
    },
    /**
     * 清空过滤筛选条件
     */
    clearFilter() {
      this.tags = [];
      this.tagsJson = {};
      this.filter["regdate"] = [];
      this.filter["rct_phase"] = [];
      this.filter["status"] = [];
      this.filter["study_type"] = [];
      this.pageNum = 1;
      this.handleSearch();
    },
    handleCommandSort(val) {
      this.pageNum = 1;
      this.handleSearch();
    },
    /**
     * 分页
     */
    handleCurrentChange(val) {
      this.pageNum = val;
      window.scroll(0, 0);
      this.handleSearch();
    },
    /**
     * 跳转到研究总结
     */
    handleAnalysis() {
      const query = {
        keyword: this.keyword,
        numFound: this.totalNum,
        filter: JSON.stringify({
          regdate: this.filter.regdate[0] || '',
          rct_phase: this.filter.rct_phase.join('|'),
          status: this.filter.status.join('|'),
          study_type: this.filter.study_type.join('|')
        }),
        type: "clinical_search",
        searchType: "clinical"
      }
      const { href } = this.$router.resolve({
        name: 'trialAnalysis',
        query
      });
      window.open(href);
    }
  },
  destroyed () {
    let Logger = webTrackerEvent();
    Logger.push("eventType", "pageUnload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", this.currentPageUrl);
    Logger.logger();
  },
  created() {
    this.keyword = this.$route.query.key;
    this.searchType = this.$route.query.searchType;
    this.handleSearch();

    // log埋点
    this.currentPageUrl = window.location.href;
    let Logger = webTrackerEvent();
    Logger.push("eventType", "pageload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", window.location.href);
    Logger.logger();
  },
}
</script>
<style lang="less" scoped>
.clinicalTrials {
  background: #f9f9f9;
  min-height: 100vh;
  padding-bottom: 50px;
  .content {
    width: 1080px;
    margin: 0 auto;
    .header-box {
      display: flex;
      align-items: center;
    }
    .el-card__header {
      span {
        margin-left: 18px;
        font-size: 16px;
        color: #333;
        font-weight: bold;
        flex: 1;
      }
      button {
        padding: 10px 20px !important;
        border: 1px solid #409eff;
      }
    }
    .resultTtle {
      font-size: 14px;
      color: #333;
      .pointData {
        font-size: 12px;
        color: #eb7400;
        margin-bottom: 5px;
      }
      .totalnum-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .filter-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        // margin-left: 120px;
        // margin-right: auto;
        .filter-list {
          margin-right: 50px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .sort-box {
        display: flex;
        align-items: center;
      }
    }
    .tags {
      margin-top: 20px;
      em {
        font-size: 12px;
        color: #6098db;
      }
      span {
        margin: 0 10px 10px 0;
      }
      .clearBtn {
        line-height: 32px;
        display: flex;
        justify-content: flex-end;
        img {
          width: 20px;
          height: 20px;
          display: block;
          margin-right: 10px;
          margin-top: 6px;
        }
      }
    }
    .resultList {
      margin-top: 20px;
      font-size: 14px;
      color: #333;
      border-bottom: none;
      .item {
        border: 1px solid #ccc;
        border-bottom: none;
        &:last-child {
          border-bottom: 1px solid #ccc;
        }
      }
    }
    .page {
      display: flex;
      justify-content: center;
      margin-top: 30px;
    }
    .noData {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

}
  
</style>


// WEBPACK FOOTER //
// src/views/clinicalTrials.vue